<template>
  <div>
    <form-card
      :labelText="$t('api.branch.blocks.payment.free_cover.label')"
      type="card"
    >
      <el-row :gutter="10" v-if="value.length == 0">
        <el-button
          type="primary"
          icon="el-icon-plus"
          circle
          @click="addRow(0)"
        >
        </el-button>
      </el-row>
      <el-row
        v-else
        :gutter="10"
        v-for="(fc, idx) in value"
        :key="idx"
      >
        <el-col :md="8">
          <text-field
            v-model.number="fc.pax"
            name="free_cover.pax"
            base="branch"
            dataType="uint"
            :prop="getPaxPropPath(idx, 'pax')"
            :hasLabel="idx <= 0"
            :hasDesc="idx <= 0"
            :min="1"
            :max="99"
            :required="true"
            :clearable="false"
          >
            <template slot="append-input">{{ $t('api.branch.fields.free_cover.pax.append') }}</template>
          </text-field>
        </el-col>
        <el-col :md="12">
          <time-field
            v-model="fc.dateRange"
            name="free_cover.month"
            base="branch"
            dataType="monthrange"
            rangeSeparator=" ~ "
            :startPlaceholder="$t('api.branch.fields.free_cover.start_month.placeholder')"
            :endPlaceholder="$t('api.branch.fields.free_cover.end_month.placeholder')"
            :hasLabel="idx <= 0"
            :required="true"
            :rules="getFreeCoverMonthRules(idx)"
            @change="handleDateChange(idx, fc.dateRange)"
          >
          </time-field>
        </el-col>
        <el-col :md="4">
          <form-item
            :label="$t('api.action')"
            name="action"
            :hasLabel="idx <= 0"
          >
            <el-button
              type="primary"
              icon="el-icon-plus"
              circle
              @click="addRow(idx)"
            >
            </el-button>
            <el-button
              v-if="value.length >= 1"
              type="danger"
              icon="el-icon-minus"
              circle
              @click="minusRow(idx)"
            >
            </el-button>
          </form-item>
        </el-col>
      </el-row>
    </form-card>
  </div>
</template>

<script>

const defFreeCovers = {
  pax: 0,
  start_month: '',
  end_month: '',
  dateRange: ['', '']
}

export default {
  name: 'free-cover',
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newVal) {
        newVal.forEach((fc, idx) => {
          if (fc.start_month && fc.end_month) {
            const startDate = new Date(fc.start_month).setHours(0, 0, 0, 0)
            const endDate = new Date(fc.end_month).setHours(0, 0, 0, 0)
            this.$set(fc, 'dateRange', [startDate, endDate])
          } else {
            this.$set(fc, 'dateRange', ['', ''])
          }
        })
      }
    }
  },
  methods: {
    updateFreeCovers () {
      this.$emit('input', this.value)
    },
    handleDateChange (idx, dateRange) {
      if (dateRange && dateRange.length === 2) {
        const formatToYearMonth = (date) => {
          const d = new Date(date)
          return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}`
        }
        this.value[idx].start_month = formatToYearMonth(dateRange[0])
        this.value[idx].end_month = formatToYearMonth(dateRange[1])
      } else {
        this.value[idx].start_month = ''
        this.value[idx].end_month = ''
      }
      this.updateFreeCovers()
    },
    addRow (idx) {
      this.value.push(Object.assign({}, defFreeCovers))
      this.updateFreeCovers()
    },
    minusRow (idx) {
      this.$emit('delFreeCover', this.value[idx])
      this.value.splice(idx, 1)
      this.updateFreeCovers()
    },
    getPaxPropPath (idx, name) {
      return `free_cover.${idx}.${name}`
    },
    getFreeCoverMonthRules (idx) {
      const currentDateRange = this.value[idx].dateRange
      return [{
        required: true,
        validator: (rule, val, callback) => {
          if (currentDateRange[0] === '' || currentDateRange[1] === '') {
            callback(new Error(
              this.$t('api.default.error', {label: this.$t('api.branch.fields.free_cover.month.label')})
            ))
            return
          }
          const hasOverlap = this.value.some((item, index) => {
            if (index === idx) return false
            const otherDateRange = item.dateRange
            return this.isDateRangeOverlap(currentDateRange, otherDateRange)
          })
          if (hasOverlap) {
            callback(new Error(this.$t('api.branch.fields.free_cover.month.error')))
            return
          }
          callback()
        },
        trigger: 'blur'
      }]
    },
    isDateRangeOverlap (rangeA, rangeB) {
      if (!rangeA || !rangeB) {
        return false
      }
      const start1 = new Date(rangeA[0])
      const end1 = new Date(rangeA[1])
      const start2 = new Date(rangeB[0])
      const end2 = new Date(rangeB[1])
      return start1 <= end2 && start2 <= end1
    }
  }
}

</script>
